<template>
  <div
    class="c-table-cell"
    :class="{
      'c-table__cell__red': data.violationFullNameCell.isRedCell,
      'c-table__cell__blue': data.violationFullNameCell.isBlueCell,
      'c-table__cell__white': !data.violationFullNameCell.isRedCell && !data.violationFullNameCell.isBlueCell,
    }"
  >
    <div class="c-table__cell-value">
      <div class="c-table__cell__icon-wrapper">
        <svg
          v-show="data.violationFullNameCell.isImportantFoul || data.violationFullNameCell.workerId === 129"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Важное нарушение',
            placement: 'top',
          }"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 4V7M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
            stroke="#FF238D"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle cx="7" cy="10" r="1" fill="#FF238D" />
        </svg>
      </div>
      <a :href="linkToWorker" target="_blank">
        {{ data.violationFullNameCell.workerName }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "full-name-cell",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    linkToWorker() {
      const routeData = this.$router.resolve({
        path: `/personal-employee/${this.data.violationFullNameCell.workerId}/discipline?measure=fouls&sortBy=date_timestamp&sortType=desc`,
      });

      return routeData.href;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-table__cell {
  display: flex;
  &-value {
    height: 100%;
    display: flex;
    align-items: center;
  }
  &__red {
    background-color: #ffe6f2;
  }
  &__blue {
    background-color: #e1edff;
  }
  &__white {
    background-color: #fff;
  }
  &__icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15px;
    margin-right: 12px;
  }
}
</style>
